import { ChangePassword } from '@components/user/ChangePassword';
import * as UserStore from '@store/user';
import { connect } from 'react-redux';
import type { ApplicationState } from '../../store';

export default connect(
    (state: ApplicationState) => ({
        ...state.identity,
        ...UserStore.plainActions,
        moduleManager: state.modules.moduleManager,
    }),
    {
    },
)(ChangePassword as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
